
async function themeComponent(url, async=true, checkDom=false) {
  const tagName = url.replace(/.*\//, '').replace(/\?.*/, '').replace('cmp-', '').replace('.js', '');
  // camelizza il nome del tag e metti in maiuscolo la prima lettera
  const className = tagName.replace(/-([a-z])/g, (g) => g[1].toUpperCase()).replace(/^./, (g) => g.toUpperCase());
  
  // se il tag è già definito non lo carico
  if(!window[className] == undefined){
    return;
  }

  // se devo controllare il dom e non trovo il tag non lo carico
  if(checkDom && document.querySelector(tagName) == null){
    return;
  }
  
  if(async){
    import(url).catch(e => {
      console.error(`Errore nel caricamento del componente ${tagName}:`, e);
    });
  } else {
    await import(url);
  }
}
window.themeComponent = themeComponent;

function themeError(msg) {
  Utils.log('themeError', msg);
  const content = `
    <div class="toast align-items-center position-" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body">${msg}</div>
        <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
      </div>
    </div>
  `;
  const toast = document.createElement('div');
  toast.classList.add('toast-container', 'position-fixed', 'bottom-0', 'end-0', 'p-3');
  toast.innerHTML = content;
  document.body.appendChild(toast);
  const bsToast = bootstrap.Toast.getOrCreateInstance(toast.querySelector('.toast'));
  bsToast.show();
}
window.themeError = themeError;

/**
 * Handles cart errors with special treatment for "sconto termico" messages.
 * Shows a modal for "sconto termico" errors, otherwise shows a standard toast.
 * @param {string} msg - The error message to display
 */
function handleCustomError(msg) {
  // Check if the message contains "sconto termico" (case insensitive)
  if (msg.toLowerCase().includes('sconto termico')) {
    // Show the global modal with the message
    const modal = document.getElementById('global-error-modal');
    if (modal) {
      // Set the message in the modal
      const modalTitle = modal.querySelector('.modal-title');
      if (modalTitle) {
        modalTitle.textContent = msg;
      }
      // Show the modal using Bootstrap
      const bsModal = bootstrap.Modal.getOrCreateInstance(modal);
      bsModal.show();
    } else {
      // Fallback to standard toast if modal doesn't exist
      themeError(msg);
    }
  } else {
    // For other errors, use the standard toast
    themeError(msg);
  }
}
window.handleCustomError = handleCustomError;

themeComponent(theme.components['megamenu-backdrop']);

// attivo i popover di bootstrap
const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))